module.exports = "/fonts/fa-brands-400.ttf?ed2b8bf117160466ba6220a8f1da54a4";